import {sanitizePath} from '~/utils/sanitizePath'
import {type SanitizedPath, type EmptyObject} from '~/utils/types'
import {Method, SimpleAPI} from '../../SimpleAPI'

export type ExperimentVariantPathPieces = {
  callsign: string
}

export const experimentVariantPath = (
  pathPieces: ExperimentVariantPathPieces
): SanitizedPath => {
  return sanitizePath(`/fem/experiment-variant/${pathPieces.callsign}`)
}

export type ExperimentVariantResponse = {
  placeHolderVariant: 'control' | 'variant'
}

export class ExperimentVariant extends SimpleAPI<
  ExperimentVariantResponse,
  EmptyObject,
  ExperimentVariantPathPieces
> {
  // Cache for 21 days to match backend
  revalidate = 21 * 24 * 60 * 60
  method = Method.POST
  useInternalMWBUrl = true
  ignoredStatusCodes = [404]

  getPath = experimentVariantPath

  protected getMockResponse = async ({
    pathPieces,
  }: {
    pathPieces: ExperimentVariantPathPieces
  }): Promise<ExperimentVariantResponse> => {
    if (pathPieces.callsign === 'test-callsign') {
      return {
        placeHolderVariant: 'variant',
      }
    }
    return {
      placeHolderVariant: 'control',
    }
  }
}
